<div class="grid grid-cols-2 h-full">
	<div class="bg-gray-50 flex items-center justify-center">
		<img
			class="max-w-sm"
			src="assets/images/undraw/undraw_compose-email_s6kf.svg"
			alt="Closer's Email Integration"
		/>
	</div>
	<div class="px-8 py-6">
		<h3 class="h3 mb-6">Select Integration Partner</h3>
		<p class="p mb-6">
			Select email integration partner and add your desired email address to
			start using email in Closer
		</p>

		<div class="py-6">
			<hr class="border-gray-200" />
		</div>

		<div class="space-y-4">
			<!-- <label
				class="flex items-center gap-10 px-8 py-6 rounded-xl border border-gray-200 w-full hover:bg-gray-100 duration-300 cursor-pointer"
				[class.border-blue-500]="selectedProvider() === 'gmail'"
				[class.bg-blue-50]="selectedProvider() === 'gmail'"
			>
				<input
					type="radio"
					name="emailProvider"
					value="gmail"
					[checked]="selectedProvider() === 'gmail'"
					(change)="onProviderSelect('gmail')"
					class="sr-only"
				/>
				<img
					src="assets/images/emails/logos/gmail-logo.png"
					class="h-10 w-auto"
				/>
				<span class="h4 flex-1">Gmail</span>
				<div
					class="w-4 h-4 rounded-full border-2 border-gray-300 flex items-center justify-center"
					[class.border-blue-500]="selectedProvider() === 'gmail'"
					[class.bg-blue-500]="selectedProvider() === 'gmail'"
				>
					<div
						class="w-2 h-2 rounded-full bg-white"
						*ngIf="selectedProvider() === 'gmail'"
					></div>
				</div>
			</label> -->
			<label
				class="flex items-center gap-10 px-8 py-6 rounded-xl border border-gray-200 w-full hover:bg-gray-100 duration-300 cursor-pointer"
				[class.border-blue-500]="selectedProvider() === 'outlook'"
				[class.bg-blue-50]="selectedProvider() === 'outlook'"
			>
				<input
					type="radio"
					name="emailProvider"
					value="outlook"
					[checked]="selectedProvider() === 'outlook'"
					(change)="onProviderSelect('outlook')"
					class="sr-only"
				/>
				<img
					src="assets/images/emails/logos/outlook-logo.png"
					class="h-10 w-auto"
				/>
				<span class="h4 flex-1">Outlook</span>
				<div
					class="w-4 h-4 rounded-full border-2 border-gray-300 flex items-center justify-center"
					[class.border-blue-500]="selectedProvider() === 'outlook'"
					[class.bg-blue-500]="selectedProvider() === 'outlook'"
				>
					<div
						class="w-2 h-2 rounded-full bg-white"
						*ngIf="selectedProvider() === 'outlook'"
					></div>
				</div>
			</label>
		</div>
	</div>
</div>
